module.exports = __webpack_public_path__ + "img/firma-2.71c8e239.jpg";